import { StandardEvents } from '@shopify/events';

class AuvenScentNotes extends HTMLElement {
  #controller;
  #generation = 0;

  connectedCallback() {
    this.#controller = new AbortController();
    this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, this.#onSelect, {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    this.#generation += 1;
    this.#controller?.abort();
  }

  #onSelect = async (event) => {
    if (event.target?.closest('.product-details') !== this.closest('.product-details')) return;
    const generation = ++this.#generation;
    const content = this.querySelector('[data-scent-content]');
    const status = this.querySelector('[data-scent-status]');
    if (content) content.hidden = true;
    if (status) status.textContent = this.dataset.loadingLabel;
    this.setAttribute('aria-busy', 'true');

    try {
      const { detail } = await event.promise;
      if (!this.isConnected || generation !== this.#generation) return;
      const source = Array.from(detail?.html?.querySelectorAll('auven-scent-notes') || []).find(
        (panel) => panel.dataset.blockId === this.dataset.blockId
      );
      if (!source || !detail?.resource || String(detail.productId) !== this.dataset.productId) {
        if (status) status.textContent = this.dataset.emptyLabel;
        this.dataset.variantId = '';
        return;
      }
      this.innerHTML = source.innerHTML;
      this.dataset.variantId = source.dataset.variantId;
    } catch (error) {
      if (!this.isConnected || generation !== this.#generation) return;
      if (status) status.textContent = this.dataset.errorLabel;
      this.dataset.variantId = '';
    } finally {
      if (this.isConnected && generation === this.#generation) this.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('auven-scent-notes')) {
  customElements.define('auven-scent-notes', AuvenScentNotes);
}
